import axios from 'axios'

class PrerenderRepository {
  update () {
    axios.post('https://api.prerender.io/recache', {
      prerenderToken: `${PRERENDER_TOKEN}`,
      url: 'https://www.stumpthespread.com/'
    })
    axios.post('https://api.prerender.io/recache', {
      prerenderToken: `${PRERENDER_TOKEN}`,
      url: 'https://www.stumpthespread.com/freepicks'
    })
  }
}

export default new PrerenderRepository()



// WEBPACK FOOTER //
// ./src/data/prerender.repository.js